import React from 'react';
import styled from 'styled-components';

import { SectionHeadline, CtaButton } from '../styled';

const SectionHeaderContainer = styled.div`
  padding-top: 49px;
  padding-bottom: 50px;
  text-align: center;
  line-height: 38px;
`;

const SectionHeaderInner = styled.div`
  max-width: 1050px;
  padding: 0 25px;
  margin: 0 auto;
`;

const Container = styled.div`
  padding: 0 25px;
`

const HomepageHeroInner = styled.div`
  max-width: 990px;
  padding: 44px 0 50px;
  margin: 0 auto;
  text-align: center;
  border-radius: 12px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);
  margin-bottom: 50px;
`;

const Headline = styled(SectionHeadline)`
  margin: 0 auto;
  margin-bottom: 16px;
`;

const Subheadline = styled.div`
  color: #666666;
  max-width: 480px;
  margin: 0 auto;
  font-size: 18px;
  line-height: 22px;
  font-weight: 400;
  letter-spacing: 0.54px;
`;

const MainImage = styled.div`
  img {
    height: 210px;
    margin-bottom: 40px;
    border-radius: 210px;
  }
`;

const HeaderButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  position: fixed;
  bottom: 25px;
  color: white;

  /* Alvin: TODO DRY this styling */
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  @media (min-width: 992px) {
    display: block;
    width: auto;
    padding-right: 13px;
  }

  & > a {
    display: block;
    color: white;
    text-decoration: none;
  }

  @media (min-width: 992px) {
    position: absolute;
    right: 22px;
    bottom: unset;
    left: unset;
  }
`;

const HeaderButton = styled(CtaButton)`
  height: 30px;
  line-height: 32px;
  padding: 0 16px;
  width: auto;

  @media (max-width: 991px) {
    background: #1e5cb3;
    color: white;
    height: 50px;
    line-height: 50px;
    min-width: 200px;

    &:hover {
      background: #3f81df;
    }

    &:active {
      background: #133a71;
    }
  }
`;

function TcnhBanner({ input }) {
    const { primary } = input;
    return (
        <>
            <SectionHeaderContainer>
                <HeaderButtonContainer>
                    <a href={primary.link.url}>
                    <HeaderButton type="button">{primary.language.text}</HeaderButton>
                    </a>
                </HeaderButtonContainer>
                <SectionHeaderInner>
                    {primary.theme &&
                    <SectionHeadline>{primary.theme.text}</SectionHeadline>
                    }
                </SectionHeaderInner>
            </SectionHeaderContainer>
            <Container>
                <HomepageHeroInner>
                    <MainImage><img src={primary.img.url} /></MainImage>
                    <Headline>{primary.desc.text}</Headline>
                    <Subheadline>{primary.subdesc.text}</Subheadline>
                </HomepageHeroInner>
            </Container>
        </>
    );
}

export { TcnhBanner };
